/*客户管理 */
import { $http, buildHeaders } from "./index";

//获取客户列表
export const customer_list = (params) => {
  return $http.get("/admin/Customer/index", { params });
};

//获取客户详情
export const customer_detail = (id) => {
  return $http.get("/admin/Customer/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加客户
export const customer_add = (data) => {
  return $http.post("/admin/Customer/add", data, {
    headers: buildHeaders(3),
  });
};

//修改客户
export const customer_edit = (data) => {
  return $http.post("/admin/Customer/edit", data, {
    headers: buildHeaders(3),
  });
};

//删除客户
export const customer_delete = (id) => {
  return $http.post(
    "/admin/Customer/del",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};

//获取客户工资表模板
export const customer_salarytemplate_info = (customer_id) => {
  return $http.get("/admin/Customer/salaryTemplateInfo", {
    params: {
      customer_id,
    },
  });
};

//保存工资表模板
export const customer_salarytemplate_save = (data) => {
  return $http.post("/admin/Customer/salaryTemplateInfoSave", data, {
    headers: buildHeaders(3),
  });
};

//下载工资表模板
export const customer_salarytemplate_download = (id) => {
  return $http.get("/admin/Customer/salaryTemplateDownload", {
    params: { id },
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

//获取子账户列表
export const customer_subaccount_list = (params) => {
  return $http.get("/admin/Customer/subaccount", { params });
};

//获取子账户详情
export const customer_subaccount_detail = (id) => {
  return $http.get("/admin/Customer/subaccountRead?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加子账户
export const customer_subaccount_add = (data) => {
  return $http.post("/admin/Customer/subaccountAdd", data, {
    headers: buildHeaders(3),
  });
};

//修改子账户
export const customer_subaccount_edit = (data) => {
  return $http.post("/admin/Customer/subaccountEdit", data, {
    headers: buildHeaders(3),
  });
};

//删除子账户
export const customer_subaccount_delete = (id) => {
  return $http.post(
    "/admin/Customer/subaccountDel",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};

//获取客户工资表列表
export const customer_payroll_list = (params) => {
  return $http.get("/admin/Customer/payroll", { params });
};

//获取客户算税列表
export const customer_calctax_list = (params) => {
  return $http.get("/admin/Customer/calcTax", { params });
};

//获取客户发薪申请列表
export const customer_salaryrecord_list = (params) => {
  return $http.get("/admin/Customer/salaryRecord", { params });
};

//获取客户下的员工列表
export const customer_employee_list = (params) => {
  return $http.get("/admin/Customer/employee", { params });
};

//添加员工
export const customer_employee_add = (data) => {
  return $http.post("/admin/Customer/employeeAdd", data, {
    headers: buildHeaders(3),
  });
};

//获取到款记录
export const customer_bankreceived_list = (params) => {
  return $http.get("/admin/Customer/bankReceived", { params });
};

//获取开票记录
export const customer_invoice_list = (params) => {
  return $http.get("/admin/Customer/invoice", { params });
};

//申请开票
export const customer_invoice_add = (data) => {
  return $http.post("/admin/Customer/applyInvoice", data, {
    headers: buildHeaders(3),
  });
};

//获取客户应收账款
export const customer_receivablemoney = (params) => {
  return $http.get("/admin/Customer/receivableMoney", { params });
};

//获取客户列表
export const customermine_list = (params) => {
  return $http.get("/admin/MyCustomer/index", { params });
};

//获取客户详情
export const customermine_detail = (id) => {
  return $http.get("/admin/MyCustomer/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加客户
export const customermine_add = (data) => {
  return $http.post("/admin/MyCustomer/add", data, {
    headers: buildHeaders(3),
  });
};

//修改客户
export const customermine_edit = (data) => {
  return $http.post("/admin/MyCustomer/edit", data, {
    headers: buildHeaders(3),
  });
};

//删除客户
export const customermine_delete = (id) => {
  return $http.post(
    "/admin/MyCustomer/del",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};

//获取客户工资表模板
export const customermine_salarytemplate_info = (customer_id) => {
  return $http.get("/admin/MyCustomer/salaryTemplateInfo", {
    params: {
      customer_id,
    },
  });
};

//保存工资表模板
export const customermine_salarytemplate_save = (data) => {
  return $http.post("/admin/MyCustomer/salaryTemplateInfoSave", data, {
    headers: buildHeaders(3),
  });
};

//下载工资表模板
export const customermine_salarytemplate_download = (id) => {
  return $http.get("/admin/MyCustomer/salaryTemplateDownload", {
    params: { id },
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

//获取子账户列表
export const customermine_subaccount_list = (params) => {
  return $http.get("/admin/MyCustomer/subaccount", { params });
};

//获取子账户详情
export const customermine_subaccount_detail = (id) => {
  return $http.get("/admin/MyCustomer/subaccountRead?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加子账户
export const customermine_subaccount_add = (data) => {
  return $http.post("/admin/MyCustomer/subaccountAdd", data, {
    headers: buildHeaders(3),
  });
};

//修改子账户
export const customermine_subaccount_edit = (data) => {
  return $http.post("/admin/MyCustomer/subaccountEdit", data, {
    headers: buildHeaders(3),
  });
};

//删除子账户
export const customermine_subaccount_delete = (id) => {
  return $http.post(
    "/admin/MyCustomer/subaccountDel",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};

//获取客户工资表列表
export const customermine_payroll_list = (params) => {
  return $http.get("/admin/MyCustomer/payroll", { params });
};

//获取客户算税列表
export const customermine_calctax_list = (params) => {
  return $http.get("/admin/MyCustomer/calcTax", { params });
};

//获取客户发薪申请列表
export const customermine_salaryrecord_list = (params) => {
  return $http.get("/admin/MyCustomer/salaryRecord", { params });
};

//获取客户下的员工列表
export const customermine_employee_list = (params) => {
  return $http.get("/admin/MyCustomer/employee", { params });
};

//添加员工
export const customermine_employee_add = (data) => {
  return $http.post("/admin/MyCustomer/employeeAdd", data, {
    headers: buildHeaders(3),
  });
};

//获取到款记录
export const customermine_bankreceived_list = (params) => {
  return $http.get("/admin/MyCustomer/bankReceived", { params });
};

//获取开票记录
export const customermine_invoice_list = (params) => {
  return $http.get("/admin/MyCustomer/invoice", { params });
};

//申请开票
export const customermine_invoice_add = (data) => {
  return $http.post("/admin/MyCustomer/applyInvoice", data, {
    headers: buildHeaders(3),
  });
};

//获取客户应收账款
export const customermine_receivablemoney = (params) => {
  return $http.get("/admin/MyCustomer/receivableMoney", { params });
};
